import { FORM_TO_MENU_ITEM_MAP } from '../../constants/bulkEdit';
import { FORMS } from '../../constants/profiles';

export function getMenuItemFromProfileSections({ channel, menu, profile }) {
  function findSelectedForm(form) {
    return profile.getIn(['sections', form]);
  }

  function reduceMenuItems(result, items, group) {
    if (items.includes(result.item)) {
      result.group = group;
    }

    return result;
  }

  return menu
    .getIn(['sections', 'items'])
    .reduce(reduceMenuItems, { item: FORM_TO_MENU_ITEM_MAP[channel][FORMS[channel].find(findSelectedForm)] });
}
